var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":_vm.dataTestid}},[_c('div',{staticClass:"mb-1"},[_vm._v("Next "+_vm._s(_vm.count)+" runs ("+_vm._s(_vm.timezoneLabel)+")")]),_vm._l((_vm.runs),function(run,index){return _c('div',{key:run.utcIso,attrs:{"data-testid":`notification-next-runs-tooltip__run--${index}`}},[_vm._v(" "+_vm._s(run.local)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }